import SocialPostShimmer from "./SocialPostShimmer";

export { SocialPostShimmer };
